/* VERVE commercial pages: shared behaviour (concepts, Sep 2026). No dependencies.
   - Audience: ?for=founder|owner|facility|franchise (or #owner etc.) + in-page switch
   - Message match: ?angle=<key> shows the matching [data-angle] hero headline
   - Landing header, sticky mobile bar, stepped form, short direct form + booking sheet, video modal
   In Shopify this file becomes assets/verve-commercial.js, loaded by the landing sections. */
(function () {
  'use strict';
  var AUDS = ['founder', 'owner', 'facility', 'franchise'];
  var root = document.documentElement;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var params = (function () { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } })();
  function track(name, data) {
    // verve_lead carries buyer_type (commercial|home) and lead_id: GTM sends Meta's Lead from it (commercial only), and
    // lead_id doubles as Meta's eventID, so a later server-side (CAPI) copy of the same lead is counted once.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'verve_' + name, audience: root.dataset.for }, data || {}));
  }
  window.verveTrack = track;
  function leadId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'vl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function buyer(v) { return v === 'HOME' ? 'home' : v === 'COMMERCIAL' ? 'commercial' : 'not chosen'; }

  /* ---------- audience ---------- */
  var audChosen = false; // true once the visitor picks (or arrives via ?for=), so a lead never claims a default as their answer
  function initialAud() {
    var q = (params.get('for') || '').toLowerCase();
    if (AUDS.indexOf(q) > -1) { audChosen = true; return q; }
    var h = (location.hash || '').replace('#', '').toLowerCase();
    if (AUDS.indexOf(h) > -1) { audChosen = true; return h; }
    var s = store.get('verve_aud');
    if (AUDS.indexOf(s) > -1) return s;
    return root.dataset.for || 'founder';
  }
  function setAud(aud, opts) {
    if (AUDS.indexOf(aud) < 0) aud = 'founder';
    root.dataset.for = aud;
    document.querySelectorAll('[data-aud]').forEach(function (el) {
      var list = el.getAttribute('data-aud').split(/\s+/);
      el.hidden = !(list.indexOf(aud) > -1 || list.indexOf('all') > -1);
    });
    document.querySelectorAll('input[data-aud-input]').forEach(function (i) { i.checked = i.value === aud; });
    store.set('verve_aud', aud);
    if (opts && opts.user) {
      audChosen = true;
      try { var u = new URL(location.href); u.searchParams.set('for', aud); history.replaceState(null, '', u); } catch (e) {}
      track('audience_change', { to: aud });
    }
    document.dispatchEvent(new CustomEvent('verve:aud', { detail: aud }));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-aud-input]')) setAud(t.value, { user: true });
  });
  window.verveSetAud = setAud;

  /* ---------- message match (?angle=) ---------- */
  function applyAngle() {
    var a = (params.get('angle') || '').toLowerCase();
    var h = (location.hash || '').replace('#', '').toLowerCase();
    if (!a && ['lease', 'cost', 'layout', 'date'].indexOf(h) > -1) a = h;
    document.querySelectorAll('[data-angles]').forEach(function (group) {
      var items = group.querySelectorAll('[data-angle]');
      var has = a && group.querySelector('[data-angle="' + a + '"]');
      items.forEach(function (el) {
        var k = el.getAttribute('data-angle');
        el.hidden = has ? k !== a : k !== 'default';
      });
    });
  }

  /* ---------- header + mobile bar ---------- */
  function initChrome() {
    var hdr = document.querySelector('.lhdr');
    var bar = document.querySelector('.mbar');
    var solidAfter = hdr && hdr.getAttribute('data-solid-after');
    var hideNear = document.querySelectorAll('[data-hide-mbar]');
    var hidden = 0;
    if ('IntersectionObserver' in window && hideNear.length && bar) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { en.target._in = en.isIntersecting; });
        hidden = Array.prototype.some.call(hideNear, function (n) { return n._in; });
        onScroll();
      }, { threshold: 0.08 });
      hideNear.forEach(function (n) { io.observe(n); });
    }
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (hdr) {
        var limit = 40;
        if (solidAfter) { var el = document.querySelector(solidAfter); if (el) limit = el.offsetTop + el.offsetHeight - 80; }
        var solid = y > limit;
        hdr.classList.toggle('lhdr--solid', solid);
        if (hdr.hasAttribute('data-light')) hdr.classList.toggle('lhdr--light', !solid);
      }
      if (bar) {
        var after = bar.getAttribute('data-after'), from = window.innerHeight * 0.9;
        if (after) { var a = document.querySelector(after); if (a) from = a.getBoundingClientRect().top + y - window.innerHeight * 0.6; }
        bar.classList.toggle('is-on', y > from && !hidden);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- stepped form ---------- */
  function initForms() {
    document.querySelectorAll('[data-fx]').forEach(function (form) {
      var steps = Array.prototype.slice.call(form.querySelectorAll('.fx__step'));
      var meter = form.querySelector('.fx__meter');
      var count = form.querySelector('.fx__count');
      var err = form.querySelector('.fx__err');
      var i = 0;
      if (meter) meter.innerHTML = steps.map(function () { return '<i></i>'; }).join('');
      function show(n, silent) {
        i = Math.max(0, Math.min(steps.length - 1, n));
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        if (meter) meter.querySelectorAll('i').forEach(function (b, k) { b.classList.toggle('on', k <= i); });
        if (count) count.textContent = 'STEP ' + (i + 1) + ' OF ' + steps.length;
        if (err) err.hidden = true;
        form.querySelectorAll('[data-fx-back]').forEach(function (b) { b.hidden = i === 0; });
        if (!silent) track('form_step', { step: i + 1, form: form.id });
      }
      function valid(step) {
        var ok = true;
        step.querySelectorAll('[data-required-group]').forEach(function (g) {
          if (!g.querySelector('input:checked')) ok = false;
        });
        step.querySelectorAll('input[required],textarea[required]').forEach(function (f) {
          if (f.offsetParent !== null && !f.checkValidity()) ok = false;
        });
        return ok;
      }
      function next() {
        if (!valid(steps[i])) {
          if (err) { err.hidden = false; err.textContent = steps[i].getAttribute('data-error') || 'Choose an option to keep going.'; }
          var bad = steps[i].querySelector('input:invalid');
          if (bad) bad.focus();
          return;
        }
        if (i < steps.length - 1) { show(i + 1); scrollIntoViewIfNeeded(form); }
      }
      form.addEventListener('click', function (e) {
        var t = e.target.closest('[data-fx-next],[data-fx-back]');
        if (!t) return;
        e.preventDefault();
        if (t.hasAttribute('data-fx-next')) next(); else show(i - 1);
      });
      // single-choice steps advance on their own. A tap on the tile that is already
      // selected fires no change event, so remember its state at pointerdown and advance on click.
      var wasChecked = null;
      form.addEventListener('pointerdown', function (e) {
        var tile = e.target.closest('.fx__step[data-auto] .fx__tile');
        var inp = tile && tile.querySelector('input[type=radio]');
        wasChecked = inp && inp.checked ? inp : null;
      });
      form.addEventListener('click', function (e) {
        var tile = e.target.closest('.fx__step[data-auto] .fx__tile');
        if (!tile || !wasChecked || !tile.contains(wasChecked)) return;
        wasChecked = null;
        setTimeout(function () { if (steps[i].contains(tile)) next(); }, 200);
      });
      form.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.fx__step[data-auto] input[type=radio]:checked')) { e.preventDefault(); next(); }
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.type === 'radio' && t.closest('.fx__step[data-auto]')) {
          setTimeout(function () { if (steps[i].contains(t)) next(); }, 260);
        }
      });
      // file drop
      form.querySelectorAll('.fx__drop').forEach(function (drop) {
        var input = drop.querySelector('input[type=file]');
        var out = form.querySelector(drop.getAttribute('data-out'));
        function list(files) {
          if (!out) return;
          if (!files || !files.length) { out.hidden = true; return; }
          out.hidden = false;
          out.querySelector('span').textContent = Array.prototype.map.call(files, function (f) { return f.name; }).join(', ');
        }
        drop.addEventListener('click', function () { input.click(); });
        drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
        input.addEventListener('change', function () { list(input.files); });
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
        drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) { try { input.files = e.dataTransfer.files; } catch (x) {} list(e.dataTransfer.files); } });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!valid(steps[i])) { next(); return; }
        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = v instanceof File ? (v.name || '') : v; });
        data.audience = root.dataset.for;
        data.angle = params.get('angle') || '';
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) data[k] = params.get(k); });
        // follow-up questions after the short form: same contact, and the first note travels with the answers
        var isEnrich = form.hasAttribute('data-enrich');
        if (isEnrich) {
          var first = window.verveLastLead || {};
          ['firstname', 'lastname', 'email', 'phone', 'notes', 'angle', 'buyer_type', 'lead_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (first[k] && !data[k]) data[k] = first[k]; });
        }
        window.verveLastLead = data;
        var done = document.querySelector(form.getAttribute('data-done'));
        function showDone() {
          track(isEnrich ? 'lead_details' : 'lead', { form: form.id, buyer_type: buyer(data.buyer_type), lead_id: data.lead_id || '' });
          if (isEnrich) { var intro = form.parentNode.querySelector('.enrich__intro'); if (intro) intro.hidden = true; }
          if (!done) return;
          done.querySelectorAll('[data-fill]').forEach(function (el) {
            var k = el.getAttribute('data-fill');
            if (data[k]) el.textContent = data[k];
          });
          form.hidden = true; done.hidden = false;
          scrollIntoViewIfNeeded(done);
        }
        // Concept files send nothing. The Shopify build adds data-hubspot="portal/formGuid" (and data-portal on Gym Launch).
        var hs = form.getAttribute('data-hubspot');
        if (!hs) { showDone(); return; }
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        sendLead(form, data, hs).then(showDone).catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (err) { err.hidden = false; err.textContent = 'That didn’t send. Please try again, or call us on 1300 1947 48.'; }
        });
      });
      // keep step 1 audience tiles in sync with the page switch
      document.addEventListener('verve:aud', function (ev) {
        form.querySelectorAll('input[name="audience"]').forEach(function (r) { r.checked = r.value === ev.detail; });
      });
      show(0, true);
    });
  }

  /* ---------- short direct form (.qf), the booking sheet, and the optional follow-up questions ---------- */
  function initQuick() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-qf]'));
    if (!forms.length) return;
    var sheet = document.getElementById('qsheet');
    var enrich = document.querySelector('[data-enrich-home]');
    var sent = null;
    // the follow-up asks who they are: never pre-tick the page's default as if they had answered
    if (enrich && !audChosen) enrich.querySelectorAll('input[name="audience"]').forEach(function (r) { r.checked = false; });
    function openSheet(from) {
      if (!sheet || typeof sheet.showModal !== 'function') return false; // no <dialog>: the link scrolls to the form instead
      if (!sheet.open) sheet.showModal();
      root.classList.add('qs-open');
      var first = sheet.querySelector('input');
      if (first && !sent && matchMedia('(pointer: fine)').matches) first.focus(); // phones: no keyboard until they tap a field
      track('form_open', { from: from || '' });
      return true;
    }
    if (sheet) {
      sheet.addEventListener('close', function () {
        root.classList.remove('qs-open');
        // closed with the follow-up questions still open: park them under the form at the bottom of the page
        if (enrich && sheet.contains(enrich) && !enrich.querySelector('[data-enrich]').hidden) {
          var home = document.querySelector('#design-form');
          var slot = home && home.parentNode.querySelector('[data-enrich-slot]');
          if (slot) slot.appendChild(enrich);
        }
      });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-qsheet-close]')) sheet.close();
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-qf-open]');
      if (t && openSheet(t.getAttribute('data-qf-open'))) e.preventDefault();
    });
    function fill(form, data, withEnrich) {
      var done = form.parentNode.querySelector('.qf-done');
      if (!done) return null;
      done.querySelectorAll('[data-fill]').forEach(function (el) { var k = el.getAttribute('data-fill'); if (data[k]) el.textContent = data[k]; });
      form.hidden = true; done.hidden = false;
      if (withEnrich && enrich) {
        var slot = done.querySelector('[data-enrich-slot]');
        if (slot) { slot.appendChild(enrich); enrich.hidden = false; }
      }
      return done;
    }
    forms.forEach(function (form) {
      var err = form.querySelector('.fx__err');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bad = Array.prototype.filter.call(form.querySelectorAll('input[required],select[required],textarea[required]'), function (f) { return !f.checkValidity(); });
        if (bad.length) {
          if (err) { err.hidden = false; err.textContent = form.getAttribute('data-error') || 'Add your name, mobile and email, and choose commercial or home, so we can call you about your design.'; }
          bad[0].focus();
          return;
        }
        if (err) err.hidden = true;
        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : ''; });
        if ('fullname' in data) { // one Name field (pages A and B); page C asks first and last name separately for the portal
          var parts = data.fullname.split(/\s+/);
          data.firstname = parts.shift() || '';
          data.lastname = parts.join(' ');
          delete data.fullname;
        }
        if (audChosen) data.audience = root.dataset.for; else data.page_version = AUD[root.dataset.for] || root.dataset.for;
        data.angle = params.get('angle') || '';
        data.lead_id = leadId();
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) data[k] = params.get(k); });
        var btn = form.querySelector('[type=submit]');
        function ok() {
          sent = data;
          window.verveLastLead = data;
          track('lead', { form: form.id, buyer_type: buyer(data.buyer_type), lead_id: data.lead_id });
          var done = fill(form, data, true);
          forms.forEach(function (f) { if (f !== form) fill(f, data, false); }); // one lead: every copy of the form now says so
          if (done && !form.closest('dialog')) scrollIntoViewIfNeeded(done);
        }
        // Concept files send nothing. The Shopify build adds data-hubspot="portal/formGuid".
        var hs = form.getAttribute('data-hubspot');
        if (!hs) { ok(); return; }
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        sendLead(form, data, hs).then(ok).catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (err) { err.hidden = false; err.textContent = 'That didn’t send. Please try again, or call us on 1300 1947 48.'; }
        });
      });
    });
  }

  /* ---------- lead delivery (Shopify build only) ---------- */
  function cookieVal(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  var LABELS = { buyer_type: 'Commercial or home', audience: 'Buyer', page_version: 'Page version seen (audience not chosen)', stage: 'Stage', size: 'Space', budget: 'Equipment budget', opening: 'Opening', postcode: 'Site postcode', notes: 'Notes', gym_type: 'Gym type', suburb: 'Suburb or postcode', angle: 'Ad angle' };
  var AUD = { founder: 'Opening a first gym', owner: 'Upgrading or expanding', facility: 'Facility', franchise: 'Multi-site or franchise' };
  function summary(form, data) {
    var parts = [form.getAttribute('data-lead-label') || 'Website lead'];
    Object.keys(LABELS).forEach(function (k) {
      var v = data[k]; if (!v) return;
      if (k === 'audience') v = AUD[v] || v;
      if (k === 'buyer_type') v = v === 'HOME' ? 'Home gym' : v === 'COMMERCIAL' ? 'Commercial gym, studio or facility' : v;
      parts.push(LABELS[k] + ': ' + v);
    });
    if (data.floorplan) parts.push('Floor plan chosen on the form: ' + data.floorplan + ' (ask them to text or email it)');
    Object.keys(data).filter(function (k) { return /^calc_/.test(k); }).forEach(function (k) { parts.push(k.replace('calc_', 'Calculator ') + ': ' + data[k]); });
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (data[k]) parts.push(k + ': ' + data[k]); });
    if (!data.buyer_type) parts.push('Commercial or home: not chosen (sent as COMMERCIAL because HubSpot requires a value)');
    if (data.lead_id) parts.push('Lead ref: ' + data.lead_id);
    parts.push('Page: ' + location.pathname + location.search);
    return parts.join('\n');
  }
  function sendLead(form, data, hs) {
    var ids = hs.split('/');
    var fields = [
      { name: 'firstname', value: data.firstname || '' },
      { name: 'lastname', value: data.lastname || '' },
      { name: 'email', value: data.email || '' },
      { name: 'phone', value: data.phone || '' },
      { name: 'company', value: data.company || '' },
      { name: 'message', value: summary(form, data) },
      { name: 'home_commercial', value: data.buyer_type === 'HOME' ? 'HOME' : 'COMMERCIAL' } // the visitor's own answer; COMMERCIAL only if none (HubSpot requires one)
    ];
    if (data.utm_source) fields.push({ name: 'utm_source', value: data.utm_source });
    var body = { fields: fields.filter(function (f) { return f.value !== ''; }), context: { pageUri: location.href, pageName: document.title } };
    var hutk = cookieVal('hubspotutk'); if (hutk) body.context.hutk = hutk;
    var hsReq = fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + ids[0] + '/' + ids[1], {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('hubspot ' + r.status); return r; });
    // Gym Launch: also hand the sign-up to the portal so it emails the magic link.
    // The portal sends no CORS header for this domain yet, so this is a no-cors "fire and forget";
    // HubSpot is the record of the lead either way.
    var portal = form.getAttribute('data-portal');
    if (portal) setTimeout(function () { // c.js builds the portal payload in its own submit listener, which runs after this one
      if (!window.verveGymLaunchPayload) return;
      try { fetch(portal, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(window.verveGymLaunchPayload) }).catch(function () {}); } catch (e) {}
    }, 0);
    return hsReq;
  }

  function scrollIntoViewIfNeeded(el) {
    if (el.closest('dialog')) { el.scrollIntoView({ block: 'nearest' }); return; }
    var r = el.getBoundingClientRect();
    if (r.top < 70 || r.top > window.innerHeight * 0.5) {
      window.scrollTo({ top: window.scrollY + r.top - 90, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  /* ---------- video modal ---------- */
  function initVideo() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-video]');
      if (!t) return;
      e.preventDefault();
      var m = document.createElement('div');
      m.className = 'vmodal';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-label', t.getAttribute('data-title') || 'Video');
      m.innerHTML = '<video controls playsinline autoplay src="' + t.getAttribute('data-video') + '"' + (t.getAttribute('data-poster') ? ' poster="' + t.getAttribute('data-poster') + '"' : '') + '></video><button class="vmodal__x" aria-label="Close video">&times;</button>';
      document.body.appendChild(m);
      document.body.style.overflow = 'hidden';
      var v = m.querySelector('video');
      function close() { v.pause(); m.remove(); document.body.style.overflow = ''; t.focus(); }
      m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.closest('.vmodal__x')) close(); });
      document.addEventListener('keydown', function esc(ev) { if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
      m.querySelector('.vmodal__x').focus();
      track('video_open', { video: t.getAttribute('data-title') || '' });
    });
  }

  /* ---------- review note ---------- */
  function initNote() {
    var n = document.querySelector('.cnote');
    if (!n) return;
    if (store.get('verve_note_off') === '1') { n.remove(); return; }
    var b = n.querySelector('button');
    if (b) b.addEventListener('click', function () { n.remove(); store.set('verve_note_off', '1'); });
  }

  function boot() {
    setAud(initialAud());
    applyAngle();
    initChrome();
    initForms();
    initQuick();
    initVideo();
    initNote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
